export const MAX_SIZE = 10 * 1000 * 1000; // 10MB
export const MAX_FILE = 10;
export const ACCEPT_FILE_TYPES = [
  {
    mimeType: "application/pdf",
    extensions: ["pdf"],
  },
  {
    mimeType: "image/jpeg",
    extensions: ["jpeg", "jpg"],
  },
  {
    mimeType: "image/tiff",
    extensions: ["tif", "tiff"],
  },
  {
    mimeType: "image/png",
    extensions: ["png"],
  },
  {
    mimeType: "image/gif",
    extensions: ["gif"],
  },
];

export const TALENT_AVATAR_EXTENSION = [".jpg", ".jpeg", ".png", ".gif"];
export const TALENT_AVATAR_MIME_TYPES = ["image/jpg", "image/jpeg", "image/png", "image/gif"];

export const TALENT_FILE_TYPES_EXTENSION = [
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".ppt",
  ".pptx",
  ".txt",
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".zip",
  ".rar",
  ".csv",
];

export const TALENT_MINE_TYPES = [
  "application/pdf", //pdf
  "application/msword", //doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", //doc
  "application/x-ole-storage", //docx
  "application/vnd.ms-excel", //xls
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", //xlsx
  "application/vnd.ms-powerpoint", // ppt
  "application/vnd.openxmlformats-officedocument.presentationml.presentation", //pptx
  "text/plain", //txt
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/gif",
  "application/zip",
  "application/x-zip",
  "application/x-zip-compressed",
  "application/vnd.rar",
  "application/x-rar-compressed",
  "application/x-rar",
  "multipart/x-rar",
  "text/csv", //csv
];
export const MAX_LENGTH_ROWS = 210;
